export default __webpack_public_path__ + "static/media/icons8-settings.180c973c.svg";